import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Component to display loading state
 * @param {Object} props - Component props
 * @param {string} [props.message='Loading project tasks...'] - Message to display
 * @returns {React.ReactElement} Loading view component
 */
const LoadingView = ({ message = 'Loading project tasks...' }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        py: 8,
        width: '100%'
      }}
    >
      <CircularProgress size={40} color="primary" />
      <Typography variant="body1" sx={{ ml: 2, color: 'text.secondary' }}>
        {message}
      </Typography>
    </Box>
  );
};

LoadingView.propTypes = {
  message: PropTypes.string
};

export default React.memo(LoadingView);